// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import parse from 'html-react-parser';

// Components
import BlogAuthorSocial from '../blogAuthorSocial/blogAuthorSocial';
import Image from '../../image/image';

// Styles
import BlogPostAuthorInfoStyles from './blogPostAuthorInfo.styles';

export default function BlogPostAuthorInfo({ author }) {
  const firstName = author?.firstName;
  const lastName = author?.lastName;
  const description = author?.description;
  const blogProfile = author?.blogProfile;
  const profilePhoto = blogProfile?.profilePhoto1 || blogProfile?.profilePhoto2;
  const uri = author?.uri;

  return (
    <BlogPostAuthorInfoStyles>
      <div className="left">
        {profilePhoto && (
          <div className="profile-photo-wrap">
            <Image image={profilePhoto} className="profile-photo" />
          </div>
        )}
      </div>

      <div className="right">
        <h3 className="heading">About the Author</h3>
        <h3 className="name large">
          {firstName} {lastName}
        </h3>
        {blogProfile?.jobTitle && (
          <h4 className="title">{blogProfile?.jobTitle}</h4>
        )}
        <p className="description">{!!description && parse(description)}</p>
        <span className="separator" />
        <Link to={uri} className="btn dark">
          Read More by this Author
        </Link>

        <BlogAuthorSocial author={author} />
      </div>
    </BlogPostAuthorInfoStyles>
  );
}

BlogPostAuthorInfo.propTypes = {
  author: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    description: PropTypes.string,
    uri: PropTypes.string,
    blogProfile: PropTypes.shape({
      jobTitle: PropTypes.string,
      facebookProfileUrl: PropTypes.string,
      twitterProfileUrl: PropTypes.string,
      linkedinProfileUrl: PropTypes.string,
      instagramProfileUrl: PropTypes.string,
      britishPsychologicalSocietyUrl: PropTypes.string,
      profilePhoto: PropTypes.shape({
        altText: PropTypes.string,
        gatsbyImage: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
};
